import { APIEvent } from '../events/apiEvent'
import { StatusBarEvent } from '../events/statusBarEvent'
import { EventBus } from '../event-bus'

export default {

  data: function () {
    return {
      parameterList: [],
      fullParameterList: [],
      parameterName: '',
      parameterType: 'number',
      parameterMinValue: null,
      parameterMaxValue: null,
      parameterDefaultValue: null,
      filterParameterName: '',
      buttonLabel: 'Add parameter',
      minValLabel: 'Min value (e.g. -2):',
      maxValLabel: 'Max value (e.g. 20.32):',
      defValLabel: 'Default value (e.g. 4.5):',
      errorMessage: '',
      fields: {
        parameter_name: {
          label: 'Parameter Name',
          sortable: true
        },
        parameter_type: {
          label: 'Parameter Type',
          sortable: false
        },
        min: {
          label: 'Min Value',
          sortable: false
        },
        max: {
          label: 'Max Value',
          sortable: false
        },
        default: {
          label: 'Default Value',
          sortable: false
        }
      }
    }
  },
  mounted () {
    if (window.localStorage.getItem('token') === null) {
      this.$store.dispatch(APIEvent.LOGOUT, {})
    } else {
      this.fetchUserData()
    }
  },
  methods: {
    fetchUserData () {
      let options = {}

      this.$store.dispatch(APIEvent.MATLAB_PARAMETER_LIST, options)
        .then(res => {
          let paramList = []

          for (let key in res.data.params) {
            let parameter = []
            parameter['parameter_name'] = key
            parameter['parameter_type'] = res.data.params[key].type
            parameter['min'] = res.data.params[key].min
            parameter['max'] = res.data.params[key].max
            parameter['default'] = res.data.params[key].default

            paramList.push(parameter)
          }

          this.parameterList = paramList
          this.fullParameterList = paramList
        })
        .catch(function (err) {
          let msg = 'The list can not be refreshed. Please check and try again :: '
          msg += err.message
          EventBus.$emit(StatusBarEvent.ERROR, msg)
        })
    },
    myRowClickHandler (record) {
      this.parameterName = record.parameter_name
      this.parameterType = record.parameter_type
      this.parameterMinValue = JSON.stringify(record.min).replace('[', '').replace(']', '').replaceAll('"', '')
      this.parameterMaxValue = JSON.stringify(record.max).replace('[', '').replace(']', '').replaceAll('"', '')
      this.parameterDefaultValue = JSON.stringify(record.default).replace('[', '').replace(']', '').replaceAll('"', '')
      this.buttonLabel = 'Update parameter'
    },
    parameterNameChange () {
      const found = this.parameterList.find(element => element.parameter_name === this.parameterName)

      if (found !== undefined) {
        this.buttonLabel = 'Update parameter'
      } else {
        this.buttonLabel = 'Add parameter'
      }

      this.clearError()
    },
    changeParameterType () {
      if (this.parameterType === 'number') {
        this.minValLabel = 'Min value (e.g. -2):'
        this.maxValLabel = 'Man value (e.g. 20.32):'
        this.defValLabel = 'Default value (e.g. 4.5):'
      } else {
        this.minValLabel = 'Min values (comma separated e.g. -2, 0.3, 1.4):'
        this.maxValLabel = 'Man value (comma separated e.g. 20.32, 12.3, 24):'
        this.defValLabel = 'Default value (comma separated e.g. -1.5, 3.4, 12):'
      }
    },
    updateParam () {
      // this.validateInput()

      let options = {
        parameter_name: this.parameterName,
        parameter_type: this.parameterType
      }

      if (this.parameterType === 'number') {
        options.min_value = this.parameterMinValue.replaceAll('"', '')
        options.max_value = this.parameterMaxValue.replaceAll('"', '')
        options.default_value = this.parameterDefaultValue.replaceAll('"', '')
      } else {
        options.min_value = '[' + this.parameterMinValue.replaceAll('"', '') + ']'
        options.max_value = '[' + this.parameterMaxValue.replaceAll('"', '') + ']'
        options.default_value = '[' + this.parameterDefaultValue.replaceAll('"', '') + ']'
      }

      let API = this.buttonLabel === 'Add parameter' ? APIEvent.MATLAB_PARAMETER_ADD : APIEvent.MATLAB_PARAMETER_UPDATE

      this.$store.dispatch(API, options)
        .then(res => {
          if (res.data.ack === 'ack') {
            let parameter = []
            parameter['parameter_name'] = this.parameterName
            parameter['parameter_type'] = this.parameterType
            if (this.parameterType === 'number') {
              parameter['min'] = parseFloat(this.parameterMinValue.replaceAll('"', ''))
              parameter['max'] = parseFloat(this.parameterMaxValue.replaceAll('"', ''))
              parameter['default'] = parseFloat(this.parameterDefaultValue.replaceAll('"', ''))
            } else {
              parameter['min'] = '[' + this.parameterMinValue.replaceAll('"', '') + ']'
              parameter['max'] = '[' + this.parameterMaxValue.replaceAll('"', '') + ']'
              parameter['default'] = '[' + this.parameterDefaultValue.replaceAll('"', '') + ']'
            }

            if (this.buttonLabel === 'Update parameter') {
              let idx = this.parameterList.findIndex((element) => element.parameter_name === this.parameterName)
              this.parameterList.splice(idx, 1)
            }

            this.parameterList.unshift(parameter)
          }
        })
        .catch(function (err) {
          let msg = 'The list can not be refreshed. Please check and try again :: '
          msg += err.message
          EventBus.$emit(StatusBarEvent.ERROR, msg)
        })
    },
    filterName () {
      if (this.filterParameterName === '') {
        this.parameterList = this.fullParameterList
      } else {
        this.parameterList = this.fullParameterList.filter(el => el.parameter_name.startsWith(this.filterParameterName))
      }
    },
    clearError () {
      if (this.errorMessage !== '') {
        this.errorMessage = ''
      }
    },
    validateInput () {
      if (this.parameterType === 'number') {
        this.checkInput(this.parameterMinValue, this.parameterMaxValue, this.parameterDefaultValue, this.parameterType)
      } else {
        // let minArr = JSON.parse('')
        // for()
      }
    },
    checkInput (min, max, def) {
      /*
      let reg

      if (type === 'number') {
        reg = /^[0-9.-]+$/g
      } else {
        reg = /^[0-9., -]+$/g
      }

      let res = await reg.test(min)
      if (!res) {
        this.errorMessage = 'Invalid input on "Min value(s)"'
      }

      res = await reg.test(max)
      if (!res) {
        this.errorMessage = 'Invalid input on "Max value(s)"'
      }

      res = await reg.test(def)
      if (!res) {
        this.errorMessage = 'Invalid input on "Default value(s)"'
      }
      */

      console.log(min < def)
      if (min > def) {
        this.errorMessage = 'DefaultValue has to be bigger or equal to min value'
      }

      console.log(def > max)
      if (def > max) {
        this.errorMessage = 'DefaultValue has to be smaller or equal to max value'
      }
    }
  }
}
